/**
 * Frontend password policy mirroring backend/src/utils/passwordPolicy.js
 * production rules. Always enforced in the UI so clients never show a softer
 * rule than the API can enforce in production.
 */

export const PASSWORD_MIN_LENGTH = 12;

export type PasswordValidationResult = {
  valid: boolean;
  message?: string;
};

export function validatePassword(password: string): PasswordValidationResult {
  const value = String(password ?? '');

  if (value.length < PASSWORD_MIN_LENGTH) {
    return {
      valid: false,
      message: `Password must be at least ${PASSWORD_MIN_LENGTH} characters`,
    };
  }
  if (!/[a-z]/.test(value)) {
    return { valid: false, message: 'Password must include a lowercase letter' };
  }
  if (!/[A-Z]/.test(value)) {
    return { valid: false, message: 'Password must include an uppercase letter' };
  }
  if (!/[0-9]/.test(value)) {
    return { valid: false, message: 'Password must include a number' };
  }
  if (!/[^A-Za-z0-9]/.test(value)) {
    return { valid: false, message: 'Password must include a special character' };
  }

  return { valid: true };
}

export function passwordPolicySummary(): string {
  return `At least ${PASSWORD_MIN_LENGTH} characters with uppercase, lowercase, number, and special character`;
}
